module.exports = __webpack_public_path__ + "static/pricingbackground-7beb962957903f3fdd59914f30c06e08.png";